import { render, staticRenderFns } from "./FamilyPlanInvite.vue?vue&type=template&id=341b1505&"
import script from "./FamilyPlanInvite.vue?vue&type=script&lang=ts&"
export * from "./FamilyPlanInvite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports